import { render } from "./date-separate-range.vue?vue&type=template&id=996f82c8"
import script from "./date-separate-range.vue?vue&type=script&lang=js"
export * from "./date-separate-range.vue?vue&type=script&lang=js"

import "./date-separate-range.vue?vue&type=style&index=0&id=996f82c8&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__